import { render, staticRenderFns } from "./contact-type.vue?vue&type=template&id=af608616&"
import script from "./contact-type.vue?vue&type=script&lang=js&"
export * from "./contact-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports